import React from 'react';
import { IconProps } from './IconProps';

export const MenuIcon = ({ size = IconProps.size, color = IconProps.color, className = IconProps.className }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z" 
      fill={color}
    />
  </svg>
); 